<div class="modal-header">
  <h4 class="modal-title">{{ 'Share / Visibility' | translate }}</h4>
  <button type="button" class="close" (click)="cancel()">
    <span>&times;</span>
  </button>
</div>

<div class="modal-body">
  <app-template-share-control
    [isShared]="isShared"
    [organizationLevelId]="organizationLevelId"
    [dataOrganizationLevelId]="dataOrganizationLevelId"
    [canManage]="true"
    (shareChange)="onShareChange($event)">
  </app-template-share-control>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">
    {{ 'Cancel' | translate }}
  </button>
  <button type="button" class="btn btn-primary" (click)="confirm()">
    {{ 'Save' | translate }}
  </button>
</div>
